import { render, staticRenderFns } from "./Individual.vue?vue&type=template&id=46290d25&scoped=true&"
import script from "./Individual.vue?vue&type=script&lang=js&"
export * from "./Individual.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/content.css?vue&type=style&index=0&id=46290d25&scoped=true&lang=css&"
import style1 from "./Individual.vue?vue&type=style&index=1&id=46290d25&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46290d25",
  null
  
)

export default component.exports